<template>
  <SogPage
    id="page"
    :title="_title"
  >
    <SogCard class="sog-card-without-title">
      <SogCardActions :is-toolbar="true">
        <SogCardActionButton
          :kind="SogButtonKind.Back"
        />
      </SogCardActions>
      <SogCardContent>
        <SelectProductTypeComponent v-show="_page==='producttype'" />
        <SelectProductComponent v-show="_page==='product'" />
        <ProductPriceComponent v-show="_page === 'productprice'" />
        <PremiumComponent v-show="_page === 'premium'" />
        <StoreExportBlankComponent
          v-show="_page === 'storeexportblank'"
          ref="_storeExportBlank"
        />
        <ExportBlankComponent v-show="_page === 'exportblank'" />
        <EvbComponent v-show="_page==='evb'" />
        <CashPointComponent v-show="_page === 'cashpoint'" />
      </SogCardContent>
    </SogCard>
  </SogPage>
</template>

<script setup lang="ts">
import SogPage from "@/shared/ui/SogPage.vue";
import {ref, watch} from "vue";
import {useRouter} from "vue-router";
import {useSpinner} from "@/shared/composables/SogSpinner";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import SelectProductTypeComponent from "@/modules/ShoppingCart/components/SelectProductTypeComponent.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SelectProductComponent from "@/modules/ShoppingCart/components/SelectProductComponent.vue";
import {storeToRefs} from "pinia";
import {useNavigationStore} from "@/modules/Navigation/store";
import PremiumComponent from "@/modules/ShoppingCart/components/PremiumComponent.vue";
import CashPointComponent from "@/modules/ShoppingCart/components/cashPointComponent.vue";
import ProductPriceComponent from "@/modules/ShoppingCart/components/ProductPriceComponent.vue";
import StoreExportBlankComponent from "@/modules/ShoppingCart/components/StoreExportBlankComponent.vue";
import ExportBlankComponent from "@/modules/ShoppingCart/components/ExportBlankComponent.vue";
import EvbComponent from "@/modules/ShoppingCart/components/EvbComponent.vue";
import {InsuranceType} from "@/shared/model/insuranceType";


interface Props {
  sector?: string,
  page?: string
}

const props = withDefaults(defineProps<Props>(), {sector: "purchase", page: "producttype"})

const _router = useRouter();
const _title = ref("Template")
const _spinner = useSpinner()
const _navigationStore = useNavigationStore();
const _shoppingCartStore = useShoppingCartStore();
const {currentItem, currentShoppingCart} = storeToRefs(_shoppingCartStore);
const _page = ref("");
const _storeExportBlank = ref<InstanceType<typeof StoreExportBlankComponent> | null>(null)
const _exportBlank = ref<InstanceType<typeof ExportBlankComponent> | null>(null)


watch(props, async () => {
    _title.value = props.sector === "purchase" ? "Einzelnes Produkt kaufen" : ""
    _shoppingCartStore.setSingle(true);
    _page.value = props.page
    let t_start = "";
    if (props.sector === "purchase") {
      t_start = "/producttype"
      if (props.page === "producttype") {
        _shoppingCartStore.clear()
        await _shoppingCartStore.initPurchase();
      }
    } else {
      _navigationStore.back();
      return;
    }

    /*
  if (props.page === "product" && currentItem.value.baseProductType === undefined) {
    await _router.push({path: "/shoppingcartsingleproduct/" + props.sector, replace: true})
    return;
  }
*/

    switch (_page.value) {
      case "product":
        if (currentItem.value.baseProducts.length > 0) {
          break;
        } else {
          await _router.push({path: "/shoppingcartsingleproduct/" + props.sector + t_start, replace: true})
          return;
        }
      case "productprice":
        if (currentItem.value.productPrices.length > 0) {
          break;
        } else {
          await _router.push({path: "/shoppingcartsingleproduct/" + props.sector + t_start, replace: true})
          return;
        }
      case "premium":
        if (currentItem.value.shoppingCartItem.productPrice === undefined) {
          await _router.push({path: "/shoppingcartsingleproduct/" + props.sector + t_start, replace: true})
          return;
        }
        break;
      case "storeexportblank":
        if (!currentItem.value.shoppingCartItem.productPrice) {
          await _router.push({path: "/shoppingcartsingleproduct/" + props.sector + t_start, replace: true})
          return;
        }
        await _storeExportBlank.value?.loadStoreExportBlank();
        break;
      case "exportblank":
        if (!currentItem.value.shoppingCartItem.productPrice) {
          await _router.push({path: "/shoppingcartsingleproduct/" + props.sector + t_start, replace: true})
          return;
        }
        break;
      case "evb":
        if (currentShoppingCart.value.items.find(t => t.insuranceType === InsuranceType.Kzk)?.count === 0) {
          await _router.push({path: "/shoppingcartsingleproduct/" + props.sector + t_start, replace: true})
          return;
        }
        break;
      case "store":
        if (!currentItem.value.shoppingCartItem.productPrice) {
          await _router.push({path: "/shoppingcartsingleproduct/" + props.sector + t_start, replace: true})
          return;
        }
        //await p_loadStore();
        break;
    }
  }
  ,
  {immediate: true})


</script>
<style scoped>
</style>
